import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as rawBase64Decode } from 'base-64';
import { showDuplicateLoginAlert } from '../../components/Auth/DuplicateLoginAlert';

const normalizeMeuPlanoResponse = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  let normalizedValue = value.trim();

  if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
    normalizedValue = JSON.parse(normalizedValue);
  }

  return normalizedValue;
};

const base64_decode = (value) => rawBase64Decode(normalizeMeuPlanoResponse(value));

const isMeuPlanoAuthError = (xhr) => {
  const candidates = [xhr?.message, xhr?.responseText, xhr?.responseJSON];

  return candidates.some((value) => {
    if (value === 'erro_auth') {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    let normalizedValue = value.trim();

    if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
      normalizedValue = JSON.parse(normalizedValue);
    }

    try {
      normalizedValue = base64_decode(normalizedValue);
    } catch (err) {
      return normalizedValue === 'erro_auth';
    }

    return normalizedValue === 'erro_auth';
  });
};

const handleMeuPlanoError = (xhr, reject, rejectMessage) => {
  if (isMeuPlanoAuthError(xhr)) {
    showDuplicateLoginAlert();
  }
  reject([400, { message: rejectMessage }]);
};

const getSession = () => {
  const usersRt = sessionStorage.getItem('ddesp');
  return usersRt !== null ? JSON.parse(base64_decode(usersRt)) : null;
};

const ajaxMeuPlanoEvent = ({
  type,
  act,
  key,
  ukey,
  rejectMessage = 'erro',
  extraData = {},
}) => new Promise(function (resolve, reject) {
  try {
    $.ajax({
      url: `${ENDERECO_API}src/api/controller/meuPlano_controller_dev.class.php`,
      type,
      dataType: 'json',
      data: {
        act,
        key,
        ukey,
        ...extraData,
      },
      success: function (data) {
        resolve([200, data]);
      },
      error: function (xhr) {
        handleMeuPlanoError(xhr, reject, rejectMessage);
      },
    });
  } catch (err) {
    reject([500, { message: err + ' Server Error' }]);
  }
});



const RestPlanosGet = (config) => {
  const caminho = config.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const user = storage[3];

  switch (caminho) {
    case 'getAplicativosMeuPlano':
      return ajaxMeuPlanoEvent({
        type: 'Get',
        act: 'getAplicativosMeuPlano',
        key: emp,
        ukey: user,
      });
    case 'getMeuPlanoAtual': {
      const idPlano = storage[8];
      return ajaxMeuPlanoEvent({
        type: 'Get',
        act: 'getMeuPlanoAtual',
        key: emp,
        ukey: user,
        extraData: { idPlano },
      });
    }
    case 'getLogsConsumoCte':
      return ajaxMeuPlanoEvent({
        type: 'Get',
        act: 'getLogsConsumoCte',
        key: emp,
        ukey: user,
      });
    case 'getHistoricoIa':
      return ajaxMeuPlanoEvent({
        type: 'Get',
        act: 'getHistoricoIa',
        key: emp,
        ukey: user,
      });
    case 'getPdfAnaliseIa':
      return ajaxMeuPlanoEvent({
        type: 'Get',
        act: 'getPdfAnaliseIa',
        key: emp,
        ukey: user,
        extraData: { record_id: config.record_id },
      });
    case 'getDadosCobranca': {
      const cnpjCpf = storage[2];
      return ajaxMeuPlanoEvent({
        type: 'Get',
        act: 'getDadosCobranca',
        key: emp,
        ukey: user,
        extraData: { cnpjCpf },
      });
    }
    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};


const RestPlanosPost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];

  switch (caminho) {
    case 'updateFaixaCte': {
      const { dataPost } = Arr_;
      return ajaxMeuPlanoEvent({
        type: 'Post',
        act: 'updateFaixaCte',
        key: emp,
        ukey: uid,
        extraData: { dataPost },
      });
    }
    case 'updateDadosCobranca': {
      const { dataPost } = Arr_;
      return ajaxMeuPlanoEvent({
        type: 'Post',
        act: 'updateDadosCobranca',
        key: emp,
        ukey: uid,
        extraData: { dataPost },
      });
    }
    case 'alterarPeriodicidade': {
      const { dataPost } = Arr_;
      return ajaxMeuPlanoEvent({
        type: 'Post',
        act: 'alterarPeriodicidade',
        key: emp,
        ukey: uid,
        extraData: { dataPost },
      });
    }
    case 'encerrarContaDemonstracao': {
      const { dataPost } = Arr_;
      return ajaxMeuPlanoEvent({
        type: 'Post',
        act: 'encerrarContaDemonstracao',
        key: emp,
        ukey: uid,
        extraData: { dataPost },
      });

    }
    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

export {RestPlanosPost, RestPlanosGet};